





import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class BtnFooter extends Vue {
  /**
   * paddingTop 上边距
   * paddingRight 右边距
   * paddingBottom 下边距
   * paddingLeft 左边距
   * direction 方向： left right center 默认center
   */
  @Prop({ default: '0' }) paddingLeft!: (string | number)
  @Prop({ default: '0' }) paddingTop!: (string | number)
  @Prop({ default: '0' }) paddingRight!: (string | number)
  @Prop({ default: '0' }) paddingBottom!: (string | number)
  @Prop({ default: 'center' }) direction!: string
}
